module.exports = __webpack_public_path__ + "static/media/chat.aa15ec73.png";